module.exports = __webpack_public_path__ + "img/layout-header-bg.34467922.png";